import { render, staticRenderFns } from "./TransportService.vue?vue&type=template&id=62c12ffb&"
import script from "./TransportService.vue?vue&type=script&lang=js&"
export * from "./TransportService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports